import { render, staticRenderFns } from "./FileManagementPage.vue?vue&type=template&id=9166ad62"
import script from "./FileManagementPage.vue?vue&type=script&lang=js"
export * from "./FileManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports